import { render } from "./DetailByRuleModal.vue?vue&type=template&id=a4536810"
import script from "./DetailByRuleModal.vue?vue&type=script&lang=js"
export * from "./DetailByRuleModal.vue?vue&type=script&lang=js"
script.render = render

export default script